import React from "react";

import Street from "./street";

const Streets = ({ streets, withoutRegion }) => {
	return (
		<div className={withoutRegion ? "" : "step"}>
			{streets.map((street) => {
				return <Street street={street} key={street.streetId} />;
			})}
		</div>
	);
};

export default Streets;
